import girderRest from 'platform/web-girder/plugins/girder';
function getMetadataFilterValues(folderId, keys) {
    return girderRest.get(`dive_metadata/${folderId}/metadata_keys`, {
        params: { keys },
    });
}
function filterDiveMetadata(folderId, filters, offset = 0, limit = 50, sort = 'filename', sortdir = 1) {
    return girderRest.get(`dive_metadata/${folderId}/filter`, {
        params: {
            filters, offset, limit, sort, sortdir,
        },
    });
}
function createDiveMetadataClone(folder, filters, destFolder) {
    return girderRest.post(`dive_metadata/${folder}/clone_filter`, null, {
        params: {
            baseFolder: folder, filters, destFolder,
        },
    });
}
function createDiveMetadataFolder(parentFolder, name, rootFolderId, categoricalLimit = 50, displayConfig = {
    display: ['DIVE_DatasetId', 'DIVE_Name'],
}, ffprobeMetadata = {
    import: true, keys: ['width', 'height', 'display_aspect_ratio'],
}) {
    return girderRest.post(`dive_metadata/create_metadata_folder/${parentFolder}`, null, {
        params: {
            name, rootFolderId, categoricalLimit, displayConfig, ffprobeMetadata,
        },
    });
}
function modifyDiveMetadataPermission(rootMetadataFolder, key, unlocked) {
    return girderRest.patch(`dive_metadata/${rootMetadataFolder}/modify_key_permission`, null, {
        params: {
            key, unlocked,
        },
    });
}
function addDiveMetadataKey(rootMetadataFolder, key, category, unlocked = false, valueList = [], defaultValue) {
    const values = valueList.length ? valueList.join(',') : undefined;
    return girderRest.put(`dive_metadata/${rootMetadataFolder}/add_key`, null, {
        params: {
            key, category, unlocked, values, default_value: defaultValue,
        },
    });
}
function deleteDiveMetadataKey(rootMetadataFolder, key) {
    return girderRest.delete(`dive_metadata/${rootMetadataFolder}/delete_key`, {
        params: {
            key,
        },
    });
}
function deleteDiveDatasetMetadataKey(diveDatasetId, key) {
    return girderRest.delete(`dive_metadata/${diveDatasetId}`, { params: { key } });
}
function setDiveDatasetMetadataKey(diveDatasetId, key, updateValue) {
    const value = updateValue === undefined ? null : updateValue;
    return girderRest.patch(`dive_metadata/${diveDatasetId}`, null, {
        params: {
            key, value,
        },
    });
}
async function updateDiveMetadataDisplay(folderId, key, state) {
    const resp = await girderRest.get(`folder/${folderId}`);
    const DIVEMetadataFilter = resp.data.meta.DIVEMetadataFilter;
    if (DIVEMetadataFilter) {
        const { display } = DIVEMetadataFilter;
        const { hide } = DIVEMetadataFilter;
        if (display.includes(key)) {
            display.splice(display.findIndex((item) => item === key), 1);
        }
        if (hide.includes(key)) {
            hide.splice(hide.findIndex((item) => item === key), 1);
        }
        if (state === 'display') {
            display.push(key);
        }
        if (state === 'hidden') {
            hide.push(key);
        }
        await girderRest.put(`folder/${folderId}/metadata`, { DIVEMetadataFilter });
    }
}
export { getMetadataFilterValues, filterDiveMetadata, createDiveMetadataClone, createDiveMetadataFolder, modifyDiveMetadataPermission, addDiveMetadataKey, deleteDiveMetadataKey, deleteDiveDatasetMetadataKey, setDiveDatasetMetadataKey, updateDiveMetadataDisplay, };
